import { useEffect, useRef } from "react";

// Adds `in-view` class when the element scrolls into the viewport.
export default function useReveal(options = {}) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, ...options }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [options]);
  return ref;
}
